// @flow
import type { Action } from '../actions/types';
import {
	INITIATE_FETCH_PODS,
	FETCH_PODS_SUCCESS,
	FETCH_PODS_ERROR,
	SELECT_POD,
	RESET_SELECT_POD,
	FETCH_POD_BANNERS,
	FETCH_POD_BANNERS_SUCCESS,
	FETCH_AFFILIATE,
	FETCH_AFFILIATE_SUCCESS,
	FETCH_AFFILIATE_ERROR,
	SET_AFFILIATE_DATA,
} from '../actions/types';

type PodState = {|
	pods: Array<any>,
	selectedPod: null | {},
	fetching: boolean,
	error: null | Error,
	banners: null | Array<string>,
	affiliateData?: any,
	affiliateActive: boolean,
|};

const initialState: PodState = {
	pods: [],
	selectedPod: null,
	fetching: false,
	error: null,
	banners: null,
	affiliateActive: false,
  affiliateData: null,
};

export const podReducer = (state: typeof initialState = initialState, action: Action): typeof initialState => {
	const { type, payload } = action;
	switch (type) {
		case INITIATE_FETCH_PODS:
			return {
				...state,
				fetching: true,
				pods: [],
				error: null,
			};

		case FETCH_PODS_SUCCESS:
			return {
				...state,
				pods: payload,
				error: null,
				fetching: false,
			};

		case FETCH_PODS_ERROR:
			return {
				...state,
				pods: [],
				error: payload,
				fetching: false,
			};

		case SELECT_POD:
			return {
				...state,
				selectedPod: payload,
			};

		case RESET_SELECT_POD:
			return {
				...state,
				selectedPod: null,
			};

		case FETCH_POD_BANNERS:
			return {
				...state,
				banners: null,
			};

		case FETCH_POD_BANNERS_SUCCESS:
			return {
				...state,
				banners: payload,
			};

		case FETCH_AFFILIATE:
			return {
				...state,
				fetching: true,
				error: null,
			};

		case FETCH_AFFILIATE_SUCCESS: {
			const { pod = null, affiliateData = null } = payload || {};
			const { affiliateData: oldAffiliateData } = state;
			return {
				...state,
				selectedPod: pod,
				error: null,
				fetching: false,
				affiliateActive: true,
				affiliateData: { ...(oldAffiliateData || {}), ...affiliateData },
			};
		}

		case FETCH_AFFILIATE_ERROR:
			return {
				...state,
				error: payload,
				fetching: false,
				affiliateActive: false,
				affiliateData: null,
			};

		case SET_AFFILIATE_DATA: {
			const { active, data = null } = payload || {};
			const { affiliateData = {} } = state;
			return {
				...state,
				affiliateActive: active,
				affiliateData: data ? { ...(affiliateData || {}), ...data } : null,
			};
		}

		default:
			return state;
	}
};
